import {
    SET_LANE_LOAD_STATS
} from './actionTypes'

const initialState = {
}

export default (state = initialState, action) => {
    switch (action.type) {
    case SET_LANE_LOAD_STATS: 
        return action.stats || initialState

    default:
        return state
    }
}

export { initialState }